import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

function ProtectedRoute({ children, adminOnly = false }) {
  const { currentUser, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  console.log("ProtectedRoute check:", { 
    isAuthenticated, 
    currentUser,
    adminRequired: adminOnly,
    isAdmin: currentUser?.isAdmin,
    role: currentUser?.role
  });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if admin privileges are required and if the user has them
  if (adminOnly && !currentUser.isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default ProtectedRoute;
